export default __webpack_public_path__ + "static/media/icon-share-white.e9cb2615.svg";